import { ExclamationTriangleIcon, Tooltip } from "@sundae/ui-toolkit";
import { FC } from "react";
import { IAssetMetaData } from "../../types/Asset.types";

const AssetMetaDataWarning: FC<Pick<IAssetMetaData, "warning">> = ({ warning }) => {
  return !!warning ? (
    <Tooltip
      tooltipLabel={warning}
      primitiveProps={{
        trigger: { asChild: true },
      }}
      trigger={
        <ExclamationTriangleIcon
          className="!dark:text-warning-300 self-center !text-warning-300"
          width={16}
          height={16}
        />
      }
    />
  ) : (
    <ExclamationTriangleIcon
      className="!dark:text-warning-300 self-center !text-warning-300"
      width={16}
      height={16}
    />
  );
};

export default AssetMetaDataWarning;
